import React from "react";
import { VideoQualityType } from "@/types/GlobalTypes";

import "./index.scss";
import { isPortrait } from "@/modules/commonMobile";

interface IProps {
    quality: VideoQualityType,
    changeQuality: () => void,
    txtTooltip?: string,
    pcode?: string,
}

type IState = {
    shown: boolean,
};

export default class StreamingQualityButton extends React.Component<IProps, IState> {
    UNSAFE_componentWillMount() {
        const popupStreamingQuality = localStorage.getItem('popup_streaming_quality' + this.props.pcode) === 'shown';
        
        this.setState(prevState => ({
            ...prevState,
            shown: popupStreamingQuality
        }));
    }

    render() {
        return (
                <div className="video-quality-button">
                    <div onClick={this.props.changeQuality}>
                    {this.props.quality.toUpperCase()}</div>

                    {
                        isPortrait() || this.state.shown ? null : 
                        <div className="popup-new">
                            {this.props.txtTooltip}
                            <span className="closebtn" onClick={this.handleClosePopup}>&times;</span>
                        </div>
                    }
                </div>
        )
    }

    handleClosePopup = () => {
        localStorage.setItem('popup_streaming_quality' + this.props.pcode, "shown");
        this.setState(prevState => ({
            ...prevState,
            shown: true
        }));
    }
}